import { render } from "./TopPageView.vue?vue&type=template&id=53b07e21&scoped=true&ts=true"
import script from "./TopPageView.vue?vue&type=script&lang=ts"
export * from "./TopPageView.vue?vue&type=script&lang=ts"

import "./TopPageView.vue?vue&type=style&index=0&id=53b07e21&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b07e21"]])

export default __exports__